var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version-info"},[_vm._v(" ©2024-present 新潮传媒集团 "),(_vm.version)?_c('span',[_vm._v(" v"+_vm._s(_vm.version))]):_vm._e(),(_vm.env)?_c('span',[_vm._v(" env:"+_vm._s(_vm.env))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }